import styles from "../../../../propertydetails.module.css";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useEffect, useState } from "react";
import { ArrowLeft, Edit, MoreVertical, Plus, Search, Trash2, X } from "react-feather";
import { Dropdown } from "react-bootstrap";
import EmailSettingsForm from "./EmailSettingsForm";

const EmailSettings = ({ property_id, setLoading, setSnackbarMsg, setSnackbarOpen, setPropertyData, property_emails }) => {
    const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();
    const [openAddEmail, setOpenAddEmail] = useState(false);
    const [openEditEmail, setOpenEditEmail] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [selectedEmail, setSelectedEmail] = useState(null);
    const [emailList, setEmailList] = useState([]);
    const [filterData, setFilterData] = useState({ searchKey: "" });

    useEffect(() => {
        if (property_emails.length) {
            let emailListTemp = property_emails;

            if (filterData.searchKey !== "") {
                let inputVal = filterData.searchKey;
                inputVal = inputVal.toLowerCase();
                emailListTemp = emailListTemp.filter((item) => item.name.toLowerCase().includes(inputVal) || item.email.toLowerCase().includes(inputVal) || item.types.toLowerCase().includes(inputVal));
            }

            setEmailList(emailListTemp);
        }
    }, [property_emails, filterData]);

    const delConfirm = async () => {
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        setDeleteModalOpen(false);
        setLoading(true);

        axios.delete(process.env.REACT_APP_PROPERTY_API_URL + "v1/property-emails/" + selectedEmail?.id, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then((response) => {
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            setPropertyData((prev) => {
                let property_emails = prev?.property_emails?.filter((item) => item.id !== selectedEmail?.id);
                return { ...prev, property_emails: property_emails };
            });

            setSelectedEmail(null);

        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return <>
        <div className={`${styles.NotesSearchArea}`}>
            <div className={`${styles.NotesSearchMain}`}>
                <input type="text" placeholder="Search" className={`${styles.searchInput}`} onChange={(e) => setFilterData(prev => { return { ...prev, searchKey: e.target.value } })} />
                <Search />
            </div>
            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("property-settings:update") > -1 && <div className={`${styles.clientDoubleButton}`}>
                <Link className={`${styles.AddBUUnit}`} onClick={(e) => setOpenAddEmail(true)}>
                    <Plus /> Notification
                </Link>
            </div>}
        </div>
        <div className={`${styles.LeaseTemplateRow}`}>
            {emailList?.map(item => {
                return <div className={`${styles.LeaseTemplateCard}`} style={{ cursor: 'pointer' }} onClick={(e) => { setOpenEditEmail(true); setSelectedEmail(item); }}>
                    <div className={`${styles.LeaseTemplateCardUnder}`}>
                        <div className={`${styles.TemplateCardHead}`}>
                            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("property-settings:update") > -1 && <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                                <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                                    <MoreVertical />
                                </Dropdown.Toggle>

                                <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                                    <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setOpenEditEmail(true); setSelectedEmail(item); }}>
                                        <Edit /> Edit
                                    </Dropdown.Item>
                                    <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteModalOpen(true); setSelectedEmail(item); }}>
                                        <Trash2 /> Delete
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>}
                            <div className={`${styles.LeaseIMGSec}`}>
                                <img src="/static/img/mail.svg" alt="" />
                            </div>
                            <div className={`${styles.LeaseConSec}`}>
                                <p className={`${styles.LeaseConTitle}`}>{item?.name}</p>
                                <p className={`${styles.LeaseConTitle}`}>{item?.email}</p>
                            </div>
                        </div>
                        <div className={`${styles.TemplateCardFoot} ${styles.Email}`}>
                            {item?.type_arr?.map(i => {
                                return <span className={`${styles.PublishBadge}`}>{i}</span>
                            })}
                        </div>
                    </div>
                </div>
            })}

            {emailList.length === 0 && (<div className={`${styles.NoDataMain}`}>
                <div className={`${styles.NoDataIMG}`}>
                    <img src="/static/img/no-prospect.png" alt="No Data" />
                </div>
                <p className={`${styles.NoDataText}`}>Let's get started!</p>
                <p className={`${styles.NoDataTextSub}`}>You don't have any emails saved.</p>
            </div>)}

        </div>

        <Dialog
            open={openAddEmail}
            onClose={(e) => setOpenAddEmail(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp MobileForm"
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle id="alert-dialog-title">
                <button className={`${styles.BackAddBU}`} onClick={(e) => setOpenAddEmail(false)}><ArrowLeft /></button>
                <span>Add Email</span>
                <button onClick={(e) => setOpenAddEmail(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <EmailSettingsForm property_id={property_id} setLoading={setLoading.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setPropertyData={setPropertyData.bind(this)} setOpenAddEmail={setOpenAddEmail.bind(this)} editData={null} />
            </DialogContent>
        </Dialog>

        <Dialog
            open={openEditEmail}
            onClose={(e) => setOpenEditEmail(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp MobileForm"
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle id="alert-dialog-title">
                <button className={`${styles.BackAddBU}`} onClick={(e) => setOpenEditEmail(false)}><ArrowLeft /></button>
                <span>Update Email</span>
                <button onClick={(e) => setOpenEditEmail(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <EmailSettingsForm property_id={property_id} setLoading={setLoading.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setPropertyData={setPropertyData.bind(this)} setOpenAddEmail={setOpenEditEmail.bind(this)} editData={selectedEmail} />
            </DialogContent>
        </Dialog>

        <Dialog
            open={deleteModalOpen}
            onClose={(e) => setDeleteModalOpen()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle id="alert-dialog-title">Are you sure you want to delete the notification?<button onClick={(e) => setDeleteModalOpen()}><X /></button></DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">The notification record will be removed immediately. You can't undo this action.</label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <button className="CancelPopupBU" onClick={(e) => delConfirm()}>Delete</button>
                <button onClick={(e) => setDeleteModalOpen()} className="SubmitPopupBU">Cancel</button>
            </DialogActions>
        </Dialog>
    </>
}

export default EmailSettings;